import React, { Component } from 'react';
import Popup from './Popup';
import $ from 'jquery';

import Pricepopup from './popup/Pricepopup';
import Devicepricepopup from './popup/Devicepricepopup';
import Pointdiscountpopup from './popup/Pointdiscountpopup';
import Subsidypopup from './popup/Subsidypopup';
import Paypopup from './popup/Paypopup';
import Prediscountcardpopup from './popup/Prediscountcardpopup';
import Postdiscountcardpopup from './popup/Postdiscountcardpopup';
import Carddetailpopup from './popup/Carddetailpopup';
import Welfarepopup from './popup/Welfarepopup';
import Usimpopup from './popup/Usimpopup';
import Insurepopup from './popup/Insurepopup';
import Addpopup from './popup/Addpopup';
import Togetherpopup from './popup/Togetherpopup';
import Additionalpopup from './popup/Additionalpopup';
import CallChatpopup from './popup/CallChatpopup.js';
import BeforeGuidepopup from './popup/BeforeGuidepopup.js';

import Footer from './Footer';
import {getUrlVars,number_input_format} from './helper/format';
import {
  isMobile
} from "react-device-detect";


/*
<div className="input-icon input-icon-right cursorhand">
  <input type="text" className="form-control font18" value={this.state.device_price} readOnly/>
  <i className="font18">원</i>
</div>
*/
class Detail extends Component {
  constructor(props)
  {
    super(props);
    var searches = props.location.search.split('?');
    var params = searches[1].split('=');
    this.state = {
      model_name : '',
      device_name : '',
      popupOpen : false,
      release_price : 0,
      fee : 0,
      select_fee_idx: 0,
      bill_name : '',
      support_zone: 1,
      more_support_price: 0,
      subsidy_price : 0,
      _subsidy_price : 0,
      installment_price : 0,
      installment_fee_price: 0,
      point_discount_price: 0,
      payPrice: 0,
      pre_monthly_Fee : 0,
      select_promise_price : 0,
      price_guide_text: '',
      select_discount_month: 24,
      select_prediscount_card: null,
      select_postdiscount_card: null,
      select_welfare_item: null,
      select_insure_item: null,
      select_add_item: null,
      select_price_item: null,
      select_point_discount: null,
      preMonthFee: 0,
      select_together_product: "",
      select_together_line: "",
      select_together_price: [],
      select_together_discount_price: 0,
      select_year_index: -1,
      select_focus_line_index: -1,
      preMonth: 0,
      postMonthFee: 0,
      welfareFee:0,
      usimOption: {price:"미적용",display:"",index:0,idx:0},
      OptionType: 1,
      OptionTypeChar: ['N','C','M'],
      _pass_uk: null,
      _device_idx: 0,
      hex: "000000",
      colorname: "",
      dataLoading: false,
      ourCompany: null,
      ourCompanyIdx: 0,
      is5G: false,
      addMoreFee: 0,
	  sold_out: 0
    };

    this.interest = 5.9;
    this.planDcRate = 25;

    this.deviceKey = 0;

    var onPriceChanged = this.onPriceChanged.bind(this);

    this.loginKey = sessionStorage.getItem('loginKey');
    if( !this.loginKey || this.loginKey == "")
    {
      this.loginKey = localStorage.getItem('loginKey');
    }
    if( !this.loginKey )
    {
        window.location.href = '/Login';
        return false;
    }
  }
  componentDidMount()
  {
    var path = this.props.location.pathname;
    let data = getUrlVars();
    var key = path.split('/')[2];
    const self = this;
    if( !key )
    {
      window.location.href = '/';
      return false;
    }
    $.get('https://api.tfamily.co.kr/api/mobile/devices',{},function(data){
      var list = JSON.parse(data).data;
      for(var i=0; i< list.length ; i++)
      {
        var item = list[i];
        if( key == item.idx )
        {
          self.setState({
            device_name : item.model,
            model_name : item.name,
            release_price : item.release_price,
            subsidy_price : item.subsidy,
            _subsidy_price : item.subsidy,
            installment_price : item.release_price - item.subsidy,
            divide_month : 24,
            divide_discount_month : 24,
            monthTotalPrice : 0,
            select_promise_price : 0,
            is5G: (item.is_5g === 1) ? true : false,
			sold_out: item.sold_out
          }, self.startSetDataComplete);
        }
      }
    });

    this.deviceKey = key;
    if( data.OptionType.indexOf('#') != -1) {
      data.OptionType = data.OptionType.split('#')[0];
    }
    this.state.OptionType = data.OptionType;
    this._backIdx = data.OptionType;
    if( data.color.indexOf('#') != -1)
    {
      data.color = data.color.split('#')[0];
    }

    this.state.colorname = data.color;

    this.logoPath = "";
    this.logoPath = sessionStorage.getItem('logo');
    if( this.logoPath == "" ) {
      this.logoPath = localStorage.getItem('logo');
    }

    this.comsCheck();
    ///
  }
  startSetDataComplete()
  {
    //this.recalcInstallment();
    //console.log('A');
    this.pricePopup.dataLoad(false, this.state.is5G);
  }
  supportPopup()
  {
    //
    let select_promise_price = 0;
    let monthPrice = this.state.fee;
    var nSelPriceVat = Math.round( monthPrice * ( 25 / 100 ) );
    var nSelPrice = Math.round( ( monthPrice / 1.1 ) * ( 25 / 100 ) );
    var nMonthDcPricePoint = Math.floor(nSelPrice - nSelPrice);
    var lastPrice = 0;
    var nMonthPriceRemain = (monthPrice / 1.1) % 10;
    if ( nMonthDcPricePoint > 0 && !nMonthPriceRemain )
    {
      lastPrice = nSelPriceVat;
    } else {
      // 기본 선택약정 할인금액의 10의 자리 이하 값
      var nSelPrice100Above = parseInt((nSelPrice / 100));
      var nSelPrice100Below = nSelPrice - (nSelPrice100Above * 100);
      if ( $.inArray(nSelPrice100Below, [0, 5, 50]) >= 0 ) {
        lastPrice = nSelPriceVat;
      } else {
        if ( nSelPrice100Below < 50 )
        {
          lastPrice = (nSelPrice100Above + 0.5) * 100 * 1.1;
        } else {
          lastPrice = (Math.round(Math.round(nSelPrice) / 100)) * 100 * 1.1;
        }
      }
    }
    select_promise_price = Math.floor(lastPrice);
    //
    let v1 = this.getMonthTotalPrice(this.state._subsidy_price);
    let v2 = this.getMonthTotalPrice(0);
//console.log("S:"+ select_promise_price);
    this.popup.Open(
        this.state._subsidy_price,
        select_promise_price,
        v1 + this.state.fee,
        v2 + this.state.fee - select_promise_price,
    );
  }
  getMonthTotalPrice(subsidy_price) {
    var modelPrice = this.state.release_price - subsidy_price - this.state.payPrice - this.state.point_discount_price;
    var monthTotalPrice = Math.floor(modelPrice * (this.interest / 100) / 12 * Math.pow(1 + (this.interest / 100) / 12, this.state.divide_month) / (Math.pow(1 + (this.interest / 100) / 12, this.state.divide_month) - 1));
    var totalCommission = (monthTotalPrice * this.state.divide_month) - modelPrice;
    var monthCommission = Math.floor(totalCommission / this.state.divide_month);
    return monthTotalPrice = Math.round(monthTotalPrice / 10) * 10;
  }
  requestWelfare(subsidy, isPriceChanged)
  {
      const self = this;
      let dataSet = {
          uk: this.loginKey,
          device_idx: this.deviceKey,
          fee_idx: this.state.select_fee_idx,
          discount_type: (this.state.support_zone == 1 ) ? 'A' : 'B',
          sign_type: this.state.OptionTypeChar[this.state.OptionType-1]
      };

      if( self.state.ourCompanyIdx != 0 ) {
        dataSet.company_idx = self.state.ourCompanyIdx;
      }

      $.post('https://api.tfamily.co.kr/api/mobile/support', dataSet, function(data){
          let parsedData = JSON.parse(data);
          self.setState({
            select_point_discount: parsedData,
            point_discount_price: parsedData.data
          },()=>{
             self.requestWelfareComplete(isPriceChanged);
           });
          if( subsidy ) {
            self.requestSubsidy();
          }
          /*
          if(isPriceChanged) {
            if(self.state.support_zone === 2) {
              self.supportZone(2);
            } else {
              self.recalcInstallment();
            }
          }
          */
      });
  }
  requestWelfareComplete(isPriceChanged)
  {

    //if(isPriceChanged) {
      //this.supportZone(2);
    //  this.recalcInstallment();
    //} else {
    this.setState({
      dataLoading: false
    }, this.recalcInstallment);
    //}

    //this.recalcInstallment();
  }
  requestSubsidy()
  {
    const self = this;
    $.post('https://api.tfamily.co.kr/api/mobile/subsidy2',{
      device_idx: self.deviceKey,
      fee_idx: self.state.select_fee_idx,
      sign_type: self.state.OptionTypeChar[self.state.OptionType-1]
    }, function(data){
        let pData = JSON.parse(data);
        self.setState({
          _subsidy_price: pData.data.discount,
           subsidy_price: pData.data.discount
        }, self.recalcInstallment);
        //console.log(pData.data.discount);
    });
  }
  pricePopupOpen()
  {
    this.pricePopup.Open(null, this.state.is5G);
  }
  devicepricePopupOpen()
  {
    //this.devicepricePopup.Open(this.state.release_price);
  }
  additionalPopupOpen(type, data)
  {
    this._additionalPopup.Open(type, data);
  }
  pointdiscountPopupOpen()
  {
    this._pointdiscountPopup.Open(this.state.installment_price);
  }
  subsidyPopupOpen()
  {
    this._subsidyPopup.Open(this.state.subsidy_price);
  }
  payPopupOpen()
  {
    this._payPopup.Open(this.state.installment_price, this.state.payPrice);
  }
  prediscountCardOpen()
  {
    this._prediscountcardPopup.Open(this.state.select_prediscount_card);
  }
  postdiscountCardOpen()
  {
    this._postdiscountcardPopup.Open(this.state.select_postdiscount_card);
  }
  welfarePopupOpen()
  {
    this._welfarePopup.Open(this.state.select_welfare_item);
  }
  usimPopupOpen()
  {
    this._usimPopup.Open(this.state.usimOption);
  }
  insurePopupOpen()
  {
    this._insurePopup.Open();
  }
  addPopupOpen()
  {
    this._addPopup.Open(this.state.select_add_item);
  }
  togeterPopupOpen()
  {
    this._togeterPopup.Open(
        this.state.select_price_item
        , (this.state.welfare_item && this.state.welfare_item.type == 2 ) ? 0 : this.state.welfareFee
    );
  }
  onDevicePriceChanged(price)
  {
    this.setState({
      release_price : price
    }, this.recalcInstallment);
  }
  onPriceChanged(price)
  {
    const self = this;
    this.setState({
      bill_name : price.name,
      fee : price.price,
      select_fee_idx : price.idx,
      price_guide_text: price.call_amt + ' / ' + price.data_amt + ' / ' + price.sms_amt,
      select_price_item: price
    }, ()=>{
      if( this.state.support_zone === 2 ) {
        this.supportZone(2, true);
      }
      setTimeout(()=>{
        self.priceChangedRecalc();
      },20)
    });
  }

  priceChangedRecalc()
  {
    this.onWelfareChanged(this.state.select_welfare_item);
    setTimeout(()=>{
      if( this.state.support_zone == 1 ) {
        this.requestWelfare(true, true);
      } else {
      //  this.requestWelfare(false, true);
      }
      this.setState({
        select_together_discount_price: 0,
        select_together_product: "",
        select_together_line : "",
        select_together_price: []
      });
      this._togeterPopup.init(true);
      this._togeterPopup.passPriceItem(this.state.select_price_item);
    },20);
  }

  onPointpriceChanged(point)
  {
    this.setState({
      point_discount_price:point
    }, this.recalcInstallment);
    //this.recalcInstallment();
  }
  onSubsidyChanged(subsidy)
  {
    this.setState({
      subsidy_price : subsidy
    },this.recalcInstallment);
    //this.recalcInstallment();
  }
  onPayChanged(pay)
  {
    this.setState(
      {
        payPrice : pay
      }, this.recalcInstallment
    );
  }
  onCardChanged(card, isPre)
  {
      // 열려 있는 팝업을 닫아야 한다
      if( card.discount_min === 0 )
      {
        if( isPre )
        {
            this.setState(
                {
                    preMonthFee: 0,
                    preMonth: 0,
                    select_prediscount_card : null
                }
            );
        } else {
            this.setState({
                select_postdiscount_card: null,
                postMonthFee: 0
            })
        }
        this._prediscountcardPopup.Close();
        this._postdiscountcardPopup.Close();
      } else {
        this._carddetailPopup.Open(card, isPre);
      }
  }
  onDeviceSelect()
  {
    window.location.href = '/?idx=' + this._backIdx ;
  }
  onSelectMonthChanged(_select_discount_month)
  {
    this.setState({
        select_discount_month : _select_discount_month
    });
  }
  onCardSelected(card, monthFee, month)
  {
    // 선카드 할인
    if( month && month != 0 ) {
        this.setState({
            preMonthFee: monthFee,
            preMonth: month,
            select_prediscount_card: card
        },this.recalcInstallment);
    } else {
        this.setState({
            postMonthFee: monthFee,
            select_postdiscount_card: card
        })
    }
    this._carddetailPopup.Close();
    this._prediscountcardPopup.Close();
    this._postdiscountcardPopup.Close();
    this.recalcInstallment();
  }
  onUsimChanged(usimOption)
  {
    this.setState({
        usimOption: usimOption
    });
  }

  onWelfareChanged(welfare_item, fromTogether)
  {
    // 특정 금액 할인
    if( !welfare_item )
    {
      return ;
    }
    let disCountFee = 0;
    this._togeterPopup.zeroLineminus(disCountFee);
    if ( welfare_item.type == 0 ) {
        welfare_item = null;
        disCountFee = 0;
    }
    else if( welfare_item.type == 1 )
    {
        disCountFee = welfare_item.discount;

        if( this.state.fee > 41500 && welfare_item.discount_max != 0 )
        {
           disCountFee = welfare_item.discount_max;
        } else
        {
          disCountFee = Math.floor( welfare_item.discount + ((this.state.fee - welfare_item.discount) * 0.35) );
        }
        if (disCountFee > welfare_item.discount_max )
        {
          disCountFee = welfare_item.discount_max;
        }
        // 만약 여기에서 결합할인이 되어있다면, 4번 항목
        // 결합할인의 비용이 재계산되어야 한다
        //console.log( this._togeterPopup.state.product_index );
        if( this._togeterPopup.state.product_index == 4)
        {
            this._togeterPopup.zeroLineminus(disCountFee);
        }
    }
    else if(welfare_item.type == 2){
        //퍼센트 할인
        // 퍼센트 할인이면 결합할인 가져오고 그 가격에서 퍼센트할인
        disCountFee = (this.state.fee - this.state.select_together_discount_price) * (welfare_item.discount / 100);
        if( disCountFee > welfare_item.discount_max &&  welfare_item.discount_max != 0)
        {
          disCountFee = welfare_item.discount_max;
        }
    }
    if(!fromTogether)
    {
      this._togeterPopup.hiddenApply();
    }

    this.setState({
        select_welfare_item: welfare_item,
        welfareFee: disCountFee
    }, this.recalcInstallment);
    //

  }

  onInsureChanged(insure)
  {
    this.setState({
        select_insure_item: insure
    });
  }

  onAddChanged(services)
  {
    this.setState({
      select_add_item: services
    }, this.recalcInstallment);
  }

  removeItem(array, value) {
    var index = null;

    while ((index = array.indexOf(value)) !== -1)
        array.splice(index, 1);

    return array;
  }

  onAddRemoveChanged(index)
  {
    let results = this.state.select_add_item;
    results.splice(index, 1);
    this.setState({
      select_add_item: results
    }, this.recalcInstallment);
  }

  supportZone(type,isPriceChanged)
  {
    if(this.state.dataLoading) {
      alert('데이터 로딩중 입니다.');
      return false;
    }
    let subsidy_price = 0;
    let select_promise_price = 0;
    let monthPrice = this.state.fee - this.getCurrentDivideDiscount();

    if ( this.state.support_zone === type && !isPriceChanged ) {
      return;
    }
    if( type == 1 ) {
      subsidy_price = this.state._subsidy_price;
    } else if ( type == 2 ) {
      var nSelPriceVat = Math.round( monthPrice * ( 25 / 100 ) );
      var nSelPrice = Math.round( ( monthPrice / 1.1 ) * ( 25 / 100 ) );
      var nMonthDcPricePoint = Math.floor(nSelPrice - nSelPrice);
      var lastPrice = 0;
      var nMonthPriceRemain = (monthPrice / 1.1) % 10;
      if ( nMonthDcPricePoint > 0 && !nMonthPriceRemain )
      {
        lastPrice = nSelPriceVat;
      } else {
        // 기본 선택약정 할인금액의 10의 자리 이하 값
        var nSelPrice100Above = parseInt((nSelPrice / 100));
        var nSelPrice100Below = nSelPrice - (nSelPrice100Above * 100);
        if ( $.inArray(nSelPrice100Below, [0, 5, 50]) >= 0 ) {
          lastPrice = nSelPriceVat;
        } else {
          if ( nSelPrice100Below < 50 )
          {
            lastPrice = (nSelPrice100Above + 0.5) * 100 * 1.1;
          } else {
            lastPrice = (Math.round(Math.round(nSelPrice) / 100)) * 100 * 1.1;
          }
        }
      }
      select_promise_price = Math.floor(lastPrice);
    }
    const stateUpdate = {
      support_zone : type,
      subsidy_price : subsidy_price,
      select_promise_price : select_promise_price,
      dataLoading: true
    };

    if (type === 2) {
      stateUpdate.select_discount_month = 24;
    }

    this.setState(stateUpdate, this.supportZoneChanged);

  }
  supportZoneChanged()
  {
    if( this.state.supportZone == 1) {
      this.requestWelfare(true);
    } else {
      this.requestWelfare();
    }

    //this.recalcInstallment();
  }

  setDivideMonth(month)
  {
    this.setState({
      divide_month : month
    },this.recalcInstallment);
  }
  changeDivideDiscountMonth(month)
  {
    this.setState({
      divide_discount_month : month
    }, this.recalcInstallment);
  }
  getCurrentFee()
  {
      const self = this;
      let result = this.state.fee - this.state.select_promise_price - this.state.postMonthFee - this.state.welfareFee - this.getCurrentDivideDiscount() - this.state.select_together_discount_price + this.state.addMoreFee ;
      if( result < 0 ){
        return 0;
      }
      return result;
  }
  getCurrentDivideDiscount()
  {
    const self = this;
    let print_discount_price = 0;
    if( self.state.select_price_item && self.state.divide_discount_month == 12 )
    {
        print_discount_price = self.state.select_price_item.discount_12;
    } else if( self.state.select_price_item && self.state.divide_discount_month == 24 ){
        print_discount_price = self.state.select_price_item.discount_24;
    }
    return print_discount_price;
  }
  recalcInstallment()
  {
    var modelPrice = this.state.release_price - this.state.subsidy_price - this.state.payPrice - this.state.point_discount_price - (this.state.preMonthFee*this.state.preMonth);
    //console.log(modelPrice);
    if( modelPrice < 0 )
    {
      modelPrice = 0;
    }
    var monthTotalPrice = Math.floor(modelPrice * (this.interest / 100) / 12 * Math.pow(1 + (this.interest / 100) / 12, this.state.divide_month) / (Math.pow(1 + (this.interest / 100) / 12, this.state.divide_month) - 1));
    var totalCommission = (monthTotalPrice * this.state.divide_month) - modelPrice;
    var monthCommission = Math.floor(totalCommission / this.state.divide_month);
    monthTotalPrice = Math.round(monthTotalPrice / 10) * 10;

    var date = new Date();
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);


    let addItems = this.state.select_add_item;
    let addMorePrice = 0;
    if(addItems) {
      for (let i = 0 ; i < addItems.length ;i++) {
        addMorePrice += addItems[i].price;
      }
    }

    //var price_ = number_input_format(this.state.monthTotalPrice+this.getCurrentFee());
    //console.log(price_);
    var maybe_monthly_fee = Math.floor( ( (this.state.monthTotalPrice + this.state.fee + addMorePrice) / lastDay.getDate() ) * ( (lastDay.getDate() - date.getDate()) + 1 ) / 10 ) * 10;
    //maybe_monthly_fee += addMorePrice;
    //console.log(maybe_monthly_fee);
    /*
    this.setState({
      select_add_item: services
    }, this.recalcInstallment);
    */
    /*
    console.log("LAST:" + lastDay.getDate());
    console.log("DAY:" + date.getDate());
    console.log("addMorePrice:" + this.state.monthTotalPrice);
    console.log("FEE:" + this.state.fee );
    */
    this.setState({
      installment_price : modelPrice,
      monthTotalPrice : monthTotalPrice,
      installment_fee_price : totalCommission,
      //pre_monthly_Fee : maybe_monthly_fee,
      addMoreFee : addMorePrice
    }, this.displayFooter);
  }
  displayFooter()
  {
    if( this._footer )
    {
		this._footer.display(this.state.monthTotalPrice, this.getCurrentFee(), this.state.sold_out);
        //this.onWelfareChanged(this.state.select_welfare_item);
    }
    var date = new Date();
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    let lastMaybePrice = ( (this.state.monthTotalPrice+ this.getCurrentFee()) / lastDay.getDate())  * ((lastDay.getDate() - date.getDate()) + 1) ;

    this.setState({
      pre_monthly_Fee: Math.floor(lastMaybePrice)
    });
  }
  onComplete(popupType)
  {
    /*
      const self = this, welfare_idx = 0;
      let support_zone = self.state.support_zone, discount_type = 0;
      if( support_zone == 2 )
      {
        discount_type = this.state.select_discount_month;
      }

      if(self.state.select_welfare_item)
      {
        welfare_idx = self.state.select_welfare_item.idx;
      }

      $.post('http://mbadmin.nebi.co.kr/api/mobile/submit', {
            uk: self.loginKey,
            device_idx: self.deviceKey,
            fee_idx: self.state.select_price_item.idx,
            support: self.state.select_point_discount.data,
            installment_month: self.state.divide_month,
            discount_type: discount_type,
            sign_type: 'N',
            welfare_idx: welfare_idx
      }, function(data){
        let parsedData = JSON.parse(data);
        sessionStorage.setItem("backurl", parsedData.data);
        window.location.href = '/OrderComplete';
      });
      */
      this.state._pass_uk = this.loginKey;
      this.state._device_idx = this.deviceKey;

      //this.additionalPopupOpen(popupType, this.state);

      this.beforeGuidePopupOpen();
  }
  beforeGuidePopupOpen()
  {
    this._beforeGuidepopup.Open();
  }
  onComplete2(popupType)
  {
    this.state._pass_uk = this.loginKey;
    this.state._device_idx = this.deviceKey;
    this.additionalPopupOpen(popupType, this.state);
  }
  onChatCall(popupType)
  {
    this.state._pass_uk = this.loginKey;
    this.state._device_idx = this.deviceKey;

    //this.additionalPopupOpen(popupType, this.state);
    this._callChatpopup.Open(popupType, this.state);
  }
  onTogetherChanged(
      select_together_product,
      select_together_line,
      select_together_price,
      select_year_index,
      select_focus_line_index)
  {
    /*
      select_together_product: "",
      select_together_line: "",
      select_together_price: [],
      select_year_index: -1,
      select_focus_line_index: -1,
    */
    //select_together_price[0];
    let discount = 0;
    if( select_together_price[0].discount )
    {
        discount = select_together_price[0].discount;
    }

    this.setState({
        select_together_discount_price : discount,
        select_together_product: select_together_product,
        select_together_line: select_together_line,
        select_together_price,
        select_year_index,
        select_focus_line_index
    }, this.togetherRecalc);

  }
  togetherRecalc()
  {
    this.onWelfareChanged(this.state.select_welfare_item, true);
    this.recalcInstallment();
  }
  comsCheck()
  {
    const self = this;
    $.post('https://api.tfamily.co.kr/api/mobile/coms',{
      uk: this.loginKey
    } , function(result){
      let parsedData = JSON.parse(result);
      self.setState({
        ourCompany : parsedData.data
      });
    });
  //  $.post('')
  }
  outCompanyChanged(event)
  {
    //console.log(event.target.value);
    const self = this;
    this.setState({
      ourCompanyIdx : event.target.value
    },function(){
      self.requestWelfare();
    });
  }
  render()
  {
    const self = this;
    var onPriceChanged = this.onPriceChanged;

    let print_discount_price = 0;
    if( self.state.select_price_item && self.state.divide_discount_month == 12 )
    {
        print_discount_price = self.state.select_price_item.discount_12;
    } else if( self.state.select_price_item && self.state.divide_discount_month == 24 ){
        print_discount_price = self.state.select_price_item.discount_24;
    }

    //onClick={()=>{self.subsidyPopupOpen()}}

    return (
      <div className="centralize-wrapper pb140 pt40">
        <div className="centralize-inner">
          <div className="container">
            <div className="row border-bottom-1">
              <div className="col-md-8">

                <div className="titleZone">
                  <h1>
                  <a style={{color:'black'}} onClick={()=>{self.onDeviceSelect()}}><i className="fas fa-chevron-left" /> </a> &nbsp;{this.state.model_name}
                  </h1>
                  { (isMobile) ? null :
                  <div className="support_button pointer" onClick={()=>self.supportPopup()}>
                    <b>지원금 비교</b>
                  </div>}
                </div>

                <div className="contentZone">

                  <div className="row border-bottom-1">
                    <div className="col-xs-12 col-md-6 border-right">
                      <div className="text-center guideTxt"><b>단말기 구매 정보(A)</b></div>
                      <div>
                        <div className="row pb15">
                          <div className="col-xs-3 guideLabel">단말기</div>
                          <div className="col-xs-1"></div>
                          <div className="col-xs-8 ">
                            <a className="form-control btn btn-default font18" onClick={()=>{self.onDeviceSelect()}} href="#device">{this.state.device_name}</a>
                          </div>
                        </div>

                        <div className="row pb15">
                          <div className="col-xs-3 guideLabel">출고가</div>
                          <div className="col-xs-1"></div>
                          <div className="col-xs-8">
                              <a className="form-control btn btn-default font18 text-right disabled notouch" readOnly="readOnly"  onClick={()=>self.devicepricePopupOpen()} href="#deviceprice">{number_input_format(this.state.release_price)} <small>원</small></a>
                          </div>
                        </div>

                      </div>
                    </div>
                    <div className="col-xs-12 col-md-6">
                      <div className="text-center guideTxt"><b>요금 정보(B)</b></div>
                      <div>

                        <div className="row pb15">
                          <div className="col-xs-3 guideLabel">요금제</div>
                          <div className="col-xs-1"></div>
                          <div className="col-xs-8">
                            <a href="#priceTable" onClick={()=>self.pricePopupOpen()} className="form-control btn btn-default font18"><b>{this.state.bill_name}</b></a>
                          </div>
                        </div>

                        <div className="row pb15">
                          <div className="col-xs-3 guideLabel">기본료</div>
                          <div className="col-xs-1"></div>
                          <div className="col-xs-8"><a className="form-control btn btn-default disabled notouch font18 text-right" href="#device">{number_input_format(this.state.fee)} <small>원</small></a></div>
                        </div>

                      </div>
                    </div>
                  </div>

                  <div className="row subbg border3d">
                    <div className={'col-xs-12 col-md-6 border-right ' + ((this.state.support_zone == 1) ? 'zone_active' : 'zone_disactive') }>
                      <div onClick={()=>self.supportZone(1)} className={'pointer text-center guideTxt subtitle2 ' + ((this.state.support_zone == 1 ) ? 'active' : '')}><b>공통지원금</b></div>
                      <div className="pt10">
                        <div className="row pb5">
                          <div className={'col-xs-4 guideLabel ' + ( (this.state.support_zone == 1) ? '' : 'gray' )}>공통지원금</div>
                          <div className="col-xs-8">
                            <a className={'form-control btn btn-default notouch notouch font18 text-right ' + ((this.state.support_zone == 1) ? '' : 'disabled') } href="#support_price">{number_input_format(this.state.subsidy_price)} <small>원</small></a>

                          </div>
                        </div>
                        <div className="row pb18 visiblehidden">
                          <div className={'col-xs-4 guideLabel ' + ( (this.state.support_zone == 1) ? '' : 'gray' )}>추가지원금</div>
                          <div className="col-xs-8">
                          <a className="form-control btn btn-default notouch font18 text-right" href="#support_price">{number_input_format(this.state.more_support_price)} <small>원</small></a>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className={'col-xs-12 col-md-6 border-right ' + ((this.state.support_zone == 2) ? 'zone_active' : 'zone_disactive') }>
                      <div onClick={()=>self.supportZone(2)} className={'pointer text-center subtitle2 ' + ((this.state.support_zone == 2 ) ? 'active' : '')}><b>선택약정</b></div>
                      <div className="pt10">
                        <div className="row pb15">
                          <div className={'col-xs-4 guideLabel ' + ( (this.state.support_zone == 2) ? '' : 'gray' )}>선택약정</div>
                          <div className="col-xs-1"></div>
                          <div className="col-xs-8">

                            <ul className="nav nav-pills nav-justified promise">
                              { this.state.support_zone !== 2 && <li role="presentation" className={'promise1 start ' + ((this.state.select_discount_month===12) ? 'active' : 'black') } onClick={()=>{self.onSelectMonthChanged(12)}}><a href="#all">12개월</a></li> }
                              <li role="presentation" className={'promise1 ' + (this.state.support_zone === 2 ? 'start ' : '') + 'end ' + ((this.state.select_discount_month===24) ? 'active' : 'black') } onClick={()=>{self.onSelectMonthChanged(24)}}><a href="#all">24개월</a></li>
                            </ul>

                          </div>
                        </div>
                        <div className="row pb10">
                          <div className="col-xs-4"></div>
                          <div className="col-xs-8">
                            <a className="form-control btn btn-default notouch font18 text-right" href="#support_price">{number_input_format(this.state.select_promise_price)} <small>원</small></a>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div className="row">

                      <div className="col-xs-12 col-md-6 border-right">
                        <div className="row pt15 importantColor">
                          <div className="col-xs-4 guideLabel labelRed">추가 지원금</div>
                          <div className="col-xs-8">
                            <a className="form-control btn btn-default font18 text-right labelRed borderRed disabled notouch" href="#device">{number_input_format(this.state.point_discount_price)} <small>원</small></a>
                          </div>
                        </div>
                        <div className="row pt15">
                          <div className="col-xs-4 guideLabel">선할인카드</div>
                          <div className="col-xs-8">
                            <a onClick={()=>self.prediscountCardOpen()} className="form-control btn btn-default font18">
                                {(self.state.select_prediscount_card===null) ? '미적용' : number_input_format(this.state.preMonth*this.state.preMonthFee) + '원' }
                            </a>
                            <div>
                            {(self.state.select_prediscount_card!=null) ? <div className="cardName">{self.state.select_prediscount_card.name}</div> : ''}
                            </div>
                          </div>
                        </div>
                        <div className="row pt15 hide">
                          <div className="col-xs-4 guideLabel">현금납부액</div>
                          <div className="col-xs-8">
                            <a onClick={()=>{self.payPopupOpen()}} className="form-control btn btn-default font18 text-right">{number_input_format(this.state.payPrice)} <small>원</small></a>
                          </div>
                        </div>
                        <div className="row pt15">
                          <div className="col-xs-4 guideLabel">할부개월</div>
                          <div className="col-xs-8">
                          <ul className="nav nav-pills nav-justified promise calendar">
                            <li role="presentation" onClick={()=>self.setDivideMonth(12)} className={'border-gray promise1 start ' + ((this.state.divide_month == 12) ? 'active' : '') }><a href="#month12">12</a></li>
                            <li role="presentation" onClick={()=>self.setDivideMonth(18)} className={'border-gray promise1 start ' + ((this.state.divide_month == 18) ? 'active' : '')}><a href="#month18">18</a></li>
                            <li role="presentation" onClick={()=>self.setDivideMonth(24)} className={'border-gray promise1 start ' + ((this.state.divide_month == 24) ? 'active' : '')}><a href="#month24">24</a></li>
                            <li role="presentation" onClick={()=>self.setDivideMonth(30)} className={'border-gray promise1 start ' + ((this.state.divide_month == 30) ? 'active' : '')}><a href="#month30">30</a></li>
                            <li role="presentation" onClick={()=>self.setDivideMonth(36)} className={'border-gray promise1 start '  + ((this.state.divide_month == 36) ? 'active' : '')}><a href="#month36">36</a></li>
                          </ul>
                          </div>
                        </div>
                        <div className="row pt15">
                          <div className="col-xs-4 guideLabel labelRed">할부원금</div>
                          <div className="col-xs-8">
                            <a className="form-control btn btn-default font18 notouch labelRed disabled text-right">{number_input_format(self.state.installment_price)} <small>원</small></a>
                          </div>
                        </div>
                        <div className="row pt15">
                          <div className="col-xs-4 guideLabel">할부수수료</div>
                          <div className="col-xs-8">
                            <a className="form-control btn btn-default font18 notouch disabled text-right">{number_input_format(self.state.installment_fee_price)} <small>원</small></a>
                            <div className="text-right pt5">
                              원리금균듕, 연 5.9%
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xs-12 col-md-6">
                        <div className="row pt15">
                          <div className="col-xs-4 guideLabel">약정할인</div>
                          <div className="col-xs-8">
                          <ul className="nav nav-pills nav-justified promise border-gray">
                            <li role="presentation" onClick={()=>self.changeDivideDiscountMonth(12)} className={'promise1 start ' + ((self.state.divide_discount_month == 12) ? 'active' : '') }><a  href="#all">12개월</a></li>
                            <li role="presentation" onClick={()=>self.changeDivideDiscountMonth(24)} className={'promise1 end ' + ((self.state.divide_discount_month == 24) ? 'active' : '') }><a href="#all">24개월</a></li>
                          </ul>
                          </div>
                        </div>
                        <div className="row pt15" >
                          <div className="col-xs-4"></div>
                            <div className="col-xs-8">
                              <a className="form-control btn btn-default font18  text-right">{number_input_format(print_discount_price)} <small>원</small></a>
                            </div>
                        </div>
                        <div className="row pt15">
                          <div className="col-xs-4 guideLabel">복지할인</div>
                          <div className="col-xs-8">
                            <a onClick={()=>{self.welfarePopupOpen()}} className="form-control btn btn-default font18">
                                {(self.state.select_welfare_item===null) ? '미적용' : number_input_format(self.state.welfareFee) + '원' }
                            </a>
                          </div>
                        </div>
                        <div className="row pt15 hide">
                          <div className="col-xs-4 guideLabel">프로모션</div>
                          <div className="col-xs-8">
                            <a className="form-control btn btn-default font18  text-right">0 <small>원</small></a>
                          </div>
                        </div>
                        <div className="row pt15">
                          <div className="col-xs-4 guideLabel">결합할인</div>
                          <div className="col-xs-8">
                            <a onClick={()=>{self.togeterPopupOpen()}} className="form-control btn btn-default font18">
                                {(self.state.select_together_discount_price==0) ? '미적용' : number_input_format(self.state.select_together_discount_price)+' 원'}
                            </a>
                            {(self.state.select_together_discount_price !=0) ?
                            <div className="text-right">
                                {(self.state.select_together_product != "") ? self.state.select_together_product : ""}
                                &nbsp;{(self.state.select_together_line != "") ? ", " + self.state.select_together_line : ""}
                            </div> : null }
                          </div>
                        </div>
                        <div className="row pt15">
                          <div className="col-xs-4 guideLabel">청구할인카드</div>
                          <div className="col-xs-8">
                            <a onClick={()=>self.postdiscountCardOpen()} className="form-control btn btn-default font18">
                                {(self.state.select_postdiscount_card===null) ? '미적용' : number_input_format(this.state.postMonthFee) + '원' }
                            </a>
                            <div>
                                {(self.state.select_postdiscount_card!=null) ? <div className="cardName">{self.state.select_postdiscount_card.name}</div> : ''}
                            </div>
                          </div>
                        </div>
                      </div>
                  </div>

                  <div className="row">
                    <div className="col-xs-12 col-md-6 height15 border-right">
                    </div>
                    <div className="col-xs-12 col-md-6 height15">
                    </div>

                  </div>

                  <div className="row hide">

                    <div className="col-xs-12 col-md-6">
                      <div className="row">
                        <div className="col-xs-6">약정할인</div>
                        <div className="col-xs-6">약정할인</div>
                      </div>
                    </div>

                    <div className="col-xs-12 col-md-6">
                      <div className="row">
                        <div className="col-xs-6">약정할인</div>
                        <div className="col-xs-6">약정할인</div>
                      </div>
                    </div>

                  </div>

                </div>

              </div>
              <div className="col-md-4">
                <div className="text-right pt18 pb5">
                {(self.logoPath && self.logoPath !="") ?
                  <img src={'https://api.tfamily.co.kr/' + self.logoPath} className="text-right logoMax"/>
                :null}
                </div>
                <div className="contentZone bgSelectZone">
                  <div className="subTitle">청구금액 (A+B)</div>
                  <div className="subTitle2">
                      당월 예상 금액
                  </div>

                  <div className="text-right pr12 monthly">
                    <span className="smallVAT">(VAT 포함)</span> {number_input_format(self.state.pre_monthly_Fee)}원
                  </div>

                  <div className="subTitle2">
                    월별 청구 금액
                  </div>

                  <div className="subContent2">
                  {self.state.price_guide_text}
                  </div>

                  <div className="text-right pr12 monthly2">
                    <span className="smallVAT">(VAT 포함)</span> {number_input_format(self.state.monthTotalPrice+self.getCurrentFee())}원
                  </div>

                  <div className="subTitle2">
                    부가서비스
                  </div>
                  <div className="subContent">
                    <a onClick={()=>{self.addPopupOpen()}} className="form-control btn btn-default font18 text-center">+ 추가</a>
                    {(self.state.select_add_item) ?
                      <div className="pt15">
                        <table className="table priceTable">
                        <tbody>
                        {self.state.select_add_item.map((item, index)=>{
                          return (
                            <tr key={index}>
                              <td className="smallpadding font14">
                                {item.name}
                                <br/><b>{number_input_format(item.price)}원</b>
                              </td>
                              <td className="smallpadding width100 text-right">
                                <a onClick={()=>{self.onAddRemoveChanged(index)}} className="btn btn-default">삭제</a>
                              </td>
                            </tr>
                          )
                        })}
                        </tbody>
                        </table>
                      </div> : ''
                     }


                     <div>
                       { (self.state.ourCompany && self.state.ourCompany.length > 0) ?
                         <div>
                          <br/>
                           <div>회사변경</div>
                           <select onChange={self.outCompanyChanged.bind(this)} className="form-control">
                              <option value=""></option>
                             {this.state.ourCompany.map((item, index)=>{
                               return <option  key={item.idx} value={item.idx}>{item.name}</option>;
                             })}
                           </select>
                         </div>
                         : ""
                         }
                     </div>


                  </div>


                  <div className="subTitle2 hide">
                    요금제 변경 시 청구금액
                  </div>

                  <div className="subContent hide">
                    <div className="row">
                      <div className="col-xs-5 subTitle3">
                        변경 요금제
                      </div>
                      <div className="col-xs-7">
                        <a className="form-control btn btn-default font18 text-center">-</a>
                      </div>
                    </div>
                    <div className="row pt15">
                      <div className="col-xs-5 subTitle3">
                        변경 가능일자
                      </div>
                      <div className="col-xs-7">
                        <a className="form-control btn btn-default font18 text-center">-</a>
                      </div>
                    </div>
                    <div className="row pt15">
                      <div className="col-xs-5 subTitle3">
                        공시지원위약금
                      </div>
                      <div className="col-xs-7">
                        <a className="form-control btn btn-default font18 text-center">-</a>
                      </div>
                    </div>

                    <div className="row pt15">
                      <div className="col-xs-12 text-right subTitle4">
                        <span className="smallGuide">(VAT 포함)</span> 0 원
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div className="row">
                <div className="col-xs-12 pt15 c3">
                    USIM 및 휴대폰보험
                </div>
            </div>

            <div className="row pt15">
                <div className="col-xs-12 col-md-4">
                    <div className="row">
                        <div className="col-xs-5 text-center font16 pt10">
                            유심
                        </div>
                        <div className="col-xs-7">
                            <a onClick={()=>{self.usimPopupOpen();}} className="form-control btn btn-default font18 text-center">
                            {self.state.usimOption.price} {(self.state.usimOption.display!="") ? '원':''}
                            </a>
                            <div>
                            {(self.state.usimOption.display!=null) ? <div className="cardName">{self.state.usimOption.display}</div> : ''}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-md-4">
                    <div className="row">
                        <div className="col-xs-5 text-center font16 pt10">
                            휴대폰 보험
                        </div>
                        <div className="col-xs-7">
                            <a onClick={()=>{self.insurePopupOpen();}} className="form-control btn btn-default font18 text-center">
                                {(self.state.select_insure_item) ? number_input_format(self.state.select_insure_item.price) + '원' : '미적용'}
                            </a>
                            <div>
                            {(self.state.select_insure_item!=null) ? <div className="cardName">{self.state.select_insure_item.name}</div> : ''}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-md-4">
                    <div className="row hide">
                        <div className="col-xs-5 text-center font16 pt10">
                            부가서비스
                        </div>
                        <div className="col-xs-3"></div>
                        <div className="col-xs-4">
                            <a onClick={()=>{self.addPopupOpen()}} className="form-control btn btn-default font18 text-center">+ 추가</a>
                        </div>
                    </div>
                </div>
            </div>


          </div>
        </div>
        <Popup onSupportChanged={(type)=>{self.supportZone(type)}} ref={(ref)=>{this.popup = ref}}/>
        <Pricepopup onPriceChanged={onPriceChanged.bind(this)} ref={(ref)=>{this.pricePopup = ref}}/>
        <Subsidypopup onSubsidyChanged={(price)=>{this.onSubsidyChanged(price)}} ref={(ref)=>{this._subsidyPopup=ref}} />
        <Devicepricepopup onDevicePriceChanged={(price)=>{this.onDevicePriceChanged(price)}} ref={(ref)=>{this.devicepricePopup = ref }}/>
        <Pointdiscountpopup onPointpriceChanged={(point)=>{this.onPointpriceChanged(point)}} ref={(ref)=>{this._pointdiscountPopup = ref}}/>
        <Paypopup onPayChanged={(pay)=>this.onPayChanged(pay)} ref={(ref)=>{this._payPopup = ref}}/>
        <Prediscountcardpopup onCardChanged={(card,isPre)=>{this.onCardChanged(card,isPre);}} ref={(ref)=>{this._prediscountcardPopup=ref}}/>
        <Postdiscountcardpopup onCardChanged={(card,isPre)=>{this.onCardChanged(card,isPre);}} ref={(ref)=>{this._postdiscountcardPopup=ref}}/>
        <Welfarepopup onWelfareChanged={(item)=>{this.onWelfareChanged(item)}} ref={(ref)=>{this._welfarePopup=ref}}/>
        <Usimpopup onUsimChanged={(usim)=>{this.onUsimChanged(usim)}} ref={(ref)=>{this._usimPopup=ref}} />
        <Insurepopup onInsureChanged={(insure)=>{this.onInsureChanged(insure)}} ref={(ref)=>{this._insurePopup=ref}} />
        <Addpopup onAddChanged={(services)=>{this.onAddChanged(services)}} ref={(ref)=>{this._addPopup=ref}} />
        <Togetherpopup onTogetherChanged={(a,b,c,d,e)=>{self.onTogetherChanged(a,b,c,d,e)}} ref={(ref)=>{this._togeterPopup=ref;}} />

        <Carddetailpopup onCardSelected={(card,monthFee,month)=>{this.onCardSelected(card,monthFee,month);}} ref={(ref)=>{this._carddetailPopup=ref}}/>

        <Additionalpopup onAddtionalComplete={()=>{}} ref={(ref=>{this._additionalPopup=ref;})} />

        <BeforeGuidepopup onCheckComplete={(a)=>{
            self.onComplete2(a);
        }} ref={(ref)=>{this._beforeGuidepopup = ref;}} />

        <CallChatpopup ref={(ref=>{this._callChatpopup = ref;})} />
        <Footer onComplete={(a)=>{
            if( a == 'C' || a == 'T') {
                self.onChatCall(a);
            } else {
                self.onComplete(a);
            }}
            } ref={(ref)=>{this._footer = ref}} />
      </div>
    );
  }
}

export default Detail;

